import { oz } from '@weft/utils';
import type { PriceTier } from './price-tier-schema';
import { PriceTierSchema } from './price-tier-schema';

function validateTiersRanges(tiers: PriceTier[]) {
  return tiers.every(({ from, to }) => from < to);
}
  
function fromBiggerThanPreviousTo(tiers: PriceTier[]) {
  return tiers.every(({ from }, tierIndex) => tierIndex === 0 || from > tiers[tierIndex - 1].to);
}

export const PriceTiersListSchema = oz
  .array(PriceTierSchema)
  .min(1)  
  .refine(validateTiersRanges, 'tier must have normal units boundaries')
  .refine(fromBiggerThanPreviousTo, 'tiers must be ascending order')
  .openapi('PriceTiersList');

export type PriceTiersList = oz.infer<typeof PriceTiersListSchema>;